<template>
  <tml-new-popup
    name="studio-popup"
    no-scroll-content
    :fill="false"
    layout="standard"
    size="normal"
    title="Small runs online"
  >
    <template #content>
      <tml-image alt="digital printing" :src="digitalPrintImage" class="mb-2" />
      <p>
        Wholesale screen printing starts at 50 units, but for small runs of
        custom printed products you can design and order online using our
        digital printing service. It's super easy and we print the same day.
      </p>
    </template>
    <template #footer>
      <tml-button
        primary
        fill
        text="Design + order online"
        href="/studio/"
        class="mb-2"
      />
      <tml-button
        fill
        text="Order 50+ wholesale"
        @click="overlays.close('studio-popup')"
      />
    </template>
  </tml-new-popup>
</template>

<script>
import digitalPrintImage from '../assets/img/digital-print.jpg';
import {overlays} from '@teemill/modules/overlays';

export default {
  name: 'StudioPopup',
  data() {
    return {
      digitalPrintImage,
      overlays,
    };
  },
};
</script>
